import {Component, DestroyRef, inject, Input, OnInit} from "@angular/core";
import {BokkzTslDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormControl, FormGroup} from "@angular/forms";
import {BehaviorSubject, take} from "rxjs";
import {SharedUiFormControlsModule} from '@snelstart/ui-form-controls';
import {SharedUiDetailsModule} from '@snelstart/ui-details';
import {CommonModule} from '@angular/common';
import {SharedUiAlertModule} from "@snelstart/ui-alert";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {SharedUiLoadingModule} from "@snelstart/ui-loading";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-berekening',
  templateUrl: './berekening.component.html',
  styleUrls: ['./berekening.component.scss'],
  imports: [
    CommonModule,
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    SharedUiAlertModule,
    SharedUiLoadingModule
  ]
})
export class BerekeningComponent implements OnInit {

  @Input() public id!: string;
  private dataService = inject(BokkzTslDataService);
  private destroyRef = inject(DestroyRef);
  public dataVisible$ = new BehaviorSubject<boolean>(false);

  public berekeningFg = new FormGroup({
    rechtOpZorgtoeslag: new FormControl<number | null>(null),
    alOntvangenZorgtoeslag: new FormControl<number | null>(null),
    verschuldigdeZorgtoeslag: new FormControl<number | null>(null),
    rechtOpHuurtoeslag: new FormControl<number | null>(null),
    alOntvangenHuurtoeslag: new FormControl<number | null>(null),
    verschuldigdeHuurtoeslag: new FormControl<number | null>(null),
    rechtOpKOT: new FormControl<number | null>(null),
    alOntvangenKOT: new FormControl<number | null>(null),
    verschuldigdeKOT: new FormControl<number | null>(null),
    rechtOpKGB: new FormControl<number | null>(null),
    alOntvangenKGB: new FormControl<number | null>(null),
    verschuldigdeKGB: new FormControl<number | null>(null),
  })

  public totalenFG = new FormGroup({
    kot1: new FormControl<number | null>(null),
    kgb1: new FormControl<number | null>(null),
    huur1: new FormControl<number | null>(null),
    zorg1: new FormControl<number | null>(null),
    kot2: new FormControl<number | null>(null),
    kgb2: new FormControl<number | null>(null),
    huur2: new FormControl<number | null>(null),
    zorg2: new FormControl<number | null>(null),
    kot3: new FormControl<number | null>(null),
    kgb3: new FormControl<number | null>(null),
    huur3: new FormControl<number | null>(null),
    zorg3: new FormControl<number | null>(null),
    sumToeslagen: new FormControl<number | null>(null),
    sumVoorschot: new FormControl<number | null>(null),
    sumSaldo: new FormControl<number | null>(null),
  })

  public kot = {} as number;
  public huur = {} as number;
  public kgb = {} as number;
  public zorg = {} as number;
  public saldo = {} as number;

  public ngOnInit(): void {
    this.dataService.calculateLatestAllowances().pipe(
      take(1),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((value) => {
      this.berekeningFg.patchValue(value, {emitEvent: false});

      const kot1 = value?.verschuldigdeKOT || 0;
      const kgb1 = value?.verschuldigdeKGB || 0;
      const huur1 = value?.verschuldigdeHuurtoeslag || 0;
      const zorg1 = value?.verschuldigdeZorgtoeslag || 0;

      const kot2 = value?.alOntvangenKOT || 0;
      const kgb2 = value?.alOntvangenKGB || 0;
      const huur2 = value?.alOntvangenHuurtoeslag || 0;
      const zorg2 = value?.alOntvangenZorgtoeslag || 0;

      const kot3 = value?.rechtOpKOT || 0;
      const kgb3 = value?.rechtOpKGB || 0;
      const huur3 = value?.rechtOpHuurtoeslag || 0;
      const zorg3 = value?.rechtOpZorgtoeslag || 0;

      const saldo = kot1 + kgb1 + huur1 + zorg1;

      this.kot = kot1;
      this.kgb = kgb1;
      this.huur = huur1;
      this.zorg = zorg1;
      this.saldo = saldo;

      this.totalenFG.patchValue({kot1: kot1 < 0 ? kot1 * -1 : kot1}, {emitEvent: false});
      this.totalenFG.patchValue({kgb1: kgb1 < 0 ? kgb1 * -1 : kgb1}, {emitEvent: false});
      this.totalenFG.patchValue({huur1: huur1 < 0 ? huur1 * -1 : huur1}, {emitEvent: false});
      this.totalenFG.patchValue({zorg1: zorg1 < 0 ? zorg1 * -1 : zorg1}, {emitEvent: false});
      this.totalenFG.patchValue({kot2: kot2}, {emitEvent: false});
      this.totalenFG.patchValue({kgb2: kgb2}, {emitEvent: false});
      this.totalenFG.patchValue({huur2: huur2}, {emitEvent: false});
      this.totalenFG.patchValue({zorg2: zorg2}, {emitEvent: false});
      this.totalenFG.patchValue({kot3: kot3}, {emitEvent: false});
      this.totalenFG.patchValue({kgb3: kgb3}, {emitEvent: false});
      this.totalenFG.patchValue({huur3: huur3}, {emitEvent: false});
      this.totalenFG.patchValue({zorg3: zorg3}, {emitEvent: false});
      this.totalenFG.patchValue({sumSaldo: saldo < 0 ? saldo * -1 : saldo}, {emitEvent: false});
      this.totalenFG.patchValue({sumVoorschot: kot2 + kgb2 + huur2 + zorg2}, {emitEvent: false});
      this.totalenFG.patchValue({sumToeslagen: kot3 + kgb3 + huur3 + zorg3}, {emitEvent: false});
      this.berekeningFg.disable({emitEvent: false});
      this.totalenFG.disable({emitEvent: false});
      this.dataVisible$.next(true);
    })
  }
}
